export const filmTags = [
  "全部",
  "港片",
  "武侠",
  "警匪",
  "喜剧",
  "文艺",
  "动作",
  "奇幻",
  "爱情",
];

export const films = [
  {
    id: "yingxiong-bense",
    title: "英雄本色",
    en: "A Better Tomorrow",
    year: "1986",
    director: "吴宇森",
    tags: ["港片", "警匪", "动作"],
    poster:
      "https://readdy.ai/api/search-image?query=moody%20rainy%20alley%20at%20night%20with%20two%20silhouetted%20figures%20in%20long%20trench%20coats%2C%20warm%20amber%20lantern%20glow%20reflected%20in%20wet%20pavement%2C%20grainy%20vintage%201990s%20Hong%20Kong%20cinema%20poster%20style%2C%20deep%20red%20and%20gold%20tones%2C%20dramatic%20nostalgic%20mood&width=600&height=800&seq=cinema-poster-hero-01&orientation=portrait",
    summary:
      "以兄弟情义与江湖抉择为主线，是八十年代港式枪战片的代表之一，节奏与情绪都极具时代气息。",
    mood: "热血 悲情",
    duration: "95 分钟",
  },
  {
    id: "qiannv-youhun",
    title: "倩女幽魂",
    en: "A Chinese Ghost Story",
    year: "1987",
    director: "程小东",
    tags: ["港片", "奇幻", "爱情"],
    poster:
      "https://readdy.ai/api/search-image?query=misty%20ancient%20Chinese%20temple%20courtyard%20at%20dusk%20with%20a%20lone%20scholar%20holding%20a%20paper%20lantern%2C%20ethereal%20drifting%20mist%2C%20warm%20amber%20and%20jade%20glow%2C%20grainy%20vintage%20Hong%20Kong%20fantasy%20film%20poster%20style%2C%20haunting%20romantic%20mood&width=600&height=800&seq=cinema-poster-hero-02&orientation=portrait",
    summary:
      "人鬼情缘与古装奇幻结合的经典之作，气氛凄美，画面与音乐都令人印象深刻。",
    mood: "凄美 奇幻",
    duration: "98 分钟",
  },
  {
    id: "dushen",
    title: "赌神",
    en: "God of Gamblers",
    year: "1989",
    director: "王晶",
    tags: ["港片", "动作", "喜剧"],
    poster:
      "https://readdy.ai/api/search-image?query=elegant%20close%20up%20of%20a%20casino%20card%20table%20with%20playing%20cards%20and%20stacked%20chips%2C%20warm%20golden%20lamp%20light%2C%20grainy%20vintage%201990s%20Hong%20Kong%20film%20poster%20style%2C%20deep%20red%20velvet%20background%2C%20sleek%20entertaining%20mood&width=600&height=800&seq=cinema-poster-hero-03&orientation=portrait",
    summary:
      "以赌坛风云为背景，把悬疑、喜剧与动作揉在一起，是九十年代前后极具娱乐性的作品。",
    mood: "潇洒 爽快",
    duration: "126 分钟",
  },
  {
    id: "afei-zhengzhuan",
    title: "阿飞正传",
    en: "Days of Being Wild",
    year: "1990",
    director: "王家卫",
    tags: ["港片", "文艺"],
    poster:
      "https://readdy.ai/api/search-image?query=lone%20figure%20sitting%20in%20a%20dim%20retro%20Hong%20Kong%20room%20with%20a%20tall%20mirror%20and%20a%20tropical%20plant%2C%20warm%20sepia%20tones%2C%20soft%20window%20light%2C%20grainy%20cinematic%20film%20still%20style%2C%20melancholic%20lonely%20mood&width=600&height=800&seq=cinema-poster-hero-04&orientation=portrait",
    summary:
      "以六十年代为背景的文艺片，人物在流动的城市里寻找归属，充满旧日气息与低回的孤独感。",
    mood: "低回 孤寂",
    duration: "94 分钟",
  },
  {
    id: "zongheng-sihai",
    title: "纵横四海",
    en: "Once a Thief",
    year: "1991",
    director: "吴宇森",
    tags: ["港片", "动作", "爱情"],
    poster:
      "https://readdy.ai/api/search-image?query=three%20figures%20walking%20through%20an%20old%20European%20gallery%20lined%20with%20warm%20golden%20paintings%2C%20elegant%20adventurous%20atmosphere%2C%20grainy%20vintage%20Hong%20Kong%20film%20poster%20style%2C%20warm%20amber%20and%20cream%20tones%2C%20romantic%20thriller%20mood&width=600&height=800&seq=cinema-poster-hero-05&orientation=portrait",
    summary:
      "盗宝题材与浪漫动作结合的明快之作，三地取景让画面格外开阔，节奏轻快又不失情义。",
    mood: "明快 浪漫",
    duration: "108 分钟",
  },
  {
    id: "huangfeihong",
    title: "黄飞鸿",
    en: "Once Upon a Time in China",
    year: "1991",
    director: "徐克",
    tags: ["港片", "武侠", "动作"],
    poster:
      "https://readdy.ai/api/search-image?query=traditional%20Chinese%20martial%20arts%20master%20in%20a%20steady%20stance%20inside%20a%20misty%20courtyard%20with%20red%20paper%20lanterns%2C%20warm%20dramatic%20light%2C%20grainy%20vintage%20wuxia%20film%20poster%20style%2C%20deep%20red%20and%20gold%20tones%2C%20heroic%20mood&width=600&height=800&seq=cinema-poster-hero-06&orientation=portrait",
    summary:
      "以清末为背景的武侠片，把家国情怀与凌厉的功夫场面并置，是九十年代武侠热潮的开路之作。",
    mood: "正气 豪迈",
    duration: "134 分钟",
  },
  {
    id: "taoxue-weilong",
    title: "逃学威龙",
    en: "Fight Back to School",
    year: "1991",
    director: "陈嘉上",
    tags: ["港片", "喜剧"],
    poster:
      "https://readdy.ai/api/search-image?query=playful%20retro%20school%20corridor%20with%20metal%20lockers%20and%20warm%20sunlight%20streaming%20through%20windows%2C%20lighthearted%20comedy%20atmosphere%2C%20grainy%20vintage%201990s%20film%20poster%20style%2C%20cheerful%20amber%20tones&width=600&height=800&seq=cinema-poster-hero-07&orientation=portrait",
    summary:
      "警匪与校园题材混搭的喜剧，误会与笑料层层推进，是当年非常受欢迎的轻松作品。",
    mood: "轻松 逗趣",
    duration: "101 分钟",
  },
  {
    id: "xin-longmen",
    title: "新龙门客栈",
    en: "Dragon Inn",
    year: "1992",
    director: "李惠民",
    tags: ["港片", "武侠"],
    poster:
      "https://readdy.ai/api/search-image?query=lonely%20desert%20inn%20at%20sunset%20with%20travelers%20and%20hanging%20lanterns%2C%20dusty%20golden%20sand%20and%20wind%2C%20grainy%20vintage%20wuxia%20film%20poster%20style%2C%20warm%20amber%20tones%2C%20tense%20martial%20mood&width=600&height=800&seq=cinema-poster-hero-08&orientation=portrait",
    summary:
      "以边塞客栈为舞台的武侠片，江湖气息浓厚，人物性格鲜明，打斗场面至今仍被反复提起。",
    mood: "江湖 凌厉",
    duration: "88 分钟",
  },
  {
    id: "tangbohu",
    title: "唐伯虎点秋香",
    en: "Flirting Scholar",
    year: "1993",
    director: "李力持",
    tags: ["港片", "喜剧"],
    poster:
      "https://readdy.ai/api/search-image?query=colorful%20traditional%20Chinese%20scholar%20study%20with%20hanging%20scrolls%20and%20ink%20brushes%2C%20warm%20comedic%20atmosphere%2C%20grainy%20vintage%20Hong%20Kong%20comedy%20film%20poster%20style%2C%20rich%20red%20and%20gold%20palette&width=600&height=800&seq=cinema-poster-hero-09&orientation=portrait",
    summary:
      "古装喜剧的代表作之一，机智的台词与密集的笑料让它成为许多人反复回看的怀旧首选。",
    mood: "诙谐 热闹",
    duration: "102 分钟",
  },
  {
    id: "dongxie-xidu",
    title: "东邪西毒",
    en: "Ashes of Time",
    year: "1994",
    director: "王家卫",
    tags: ["港片", "文艺", "武侠"],
    poster:
      "https://readdy.ai/api/search-image?query=lone%20swordsman%20silhouette%20on%20a%20vast%20empty%20desert%20at%20golden%20hour%2C%20lonely%20melancholic%20mood%2C%20grainy%20vintage%20film%20poster%20style%2C%20warm%20amber%20and%20dust%20tones%2C%20poetic%20wuxia%20atmosphere&width=600&height=800&seq=cinema-poster-hero-10&orientation=portrait",
    summary:
      "以武侠为外壳的文艺片，叙事与影像都极富个人风格，气氛苍凉，是需要静下来慢慢体会的作品。",
    mood: "苍凉 诗意",
    duration: "99 分钟",
  },
  {
    id: "dahua-xiyou",
    title: "大话西游",
    en: "A Chinese Odyssey",
    year: "1995",
    director: "刘镇伟",
    tags: ["港片", "奇幻", "喜剧", "爱情"],
    poster:
      "https://readdy.ai/api/search-image?query=fantasy%20cliff%20edge%20with%20a%20stone%20staircase%20climbing%20into%20painted%20sunset%20clouds%2C%20romantic%20mythic%20mood%2C%20grainy%20vintage%20film%20poster%20style%2C%20warm%20golden%20and%20rose%20tones&width=600&height=800&seq=cinema-poster-hero-11&orientation=portrait",
    summary:
      "神话与喜剧交织，前半段嬉笑怒骂，后段却后劲十足，是九十年代被反复讨论的爱情叙事之一。",
    mood: "笑中带泪",
    duration: "95 分钟",
  },
  {
    id: "tianmimi",
    title: "甜蜜蜜",
    en: "Comrades: Almost a Love Story",
    year: "1996",
    director: "陈可辛",
    tags: ["港片", "爱情", "文艺"],
    poster:
      "https://readdy.ai/api/search-image?query=two%20young%20people%20riding%20an%20old%20bicycle%20along%20a%20warm%20city%20street%20at%20dusk%2C%20nostalgic%20romantic%20mood%2C%20grainy%20vintage%201990s%20film%20poster%20style%2C%20soft%20amber%20and%20honey%20tones&width=600&height=800&seq=cinema-poster-hero-12&orientation=portrait",
    summary:
      "以移民与漂泊为线索的年代情感片，普通人的聚散被拍得格外真切，是九十年代都市爱情片的代表。",
    mood: "细腻 温情",
    duration: "118 分钟",
  },
];